import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUp, BookOpen } from "lucide-react";
import { Logo, Wordmark } from "./Logo";
import { CONTACT } from "../data/content";
import { scrollToId } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-white/10 text-slate-400">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <Logo className="w-12 h-12 shrink-0" light />
            <Wordmark light />
          </div>
          <p className="text-sm leading-relaxed max-w-xs">
            Megbízható víz- és fűtésszerelő mester. Precíz munkavégzés, korrekt hozzáállás, garanciával.
          </p>
        </div>

        <div>
          <h4 className="text-white font-display font-bold mb-4">Elérhetőség</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={`tel:${CONTACT.phoneHref}`} className="flex items-center gap-2 hover:text-white"><Phone className="w-4 h-4 text-sky-400" /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4 text-sky-400" /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-sky-400" /> Budapest &amp; Keszthely környéke</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-bold mb-4">Szolgáltatási területek</h4>
          <p className="text-sm leading-relaxed">Budapest és vonzáskörzete · Keszthely és a Balaton nyugati medencéje (Hévíz, Gyenesdiás, Vonyarcvashegy és környéke).</p>
          <div className="mt-5 flex flex-col gap-2">
            <Link to="/blog" className="inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 font-semibold text-sm">
              <BookOpen className="w-4 h-4" /> Szakmai blog
            </Link>
            <button
              onClick={() => scrollToId("top")}
              className="inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 font-semibold text-sm"
            >
              <ArrowUp className="w-4 h-4" /> Vissza a tetejére
            </button>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
          <span>© {new Date().getFullYear()} Szuper Szaki – Kálmán Fülöp. Minden jog fenntartva.</span>
          <span>Egyéni vállalkozó · Víz- és fűtésszerelés</span>
        </div>
      </div>
    </footer>
  );
}
